// extracted by mini-css-extract-plugin
export default {"wrap":"PersonalArea_wrap__CUiPW","container":"PersonalArea_container__qruTv","navbar":"PersonalArea_navbar__wbEkr","content":"PersonalArea_content__5eQ2q"};